export default "__VITE_ASSET__c9236a5c__"